import React from 'react';
import BrokerageContinuum from '../BrokerageContinuum';
import Error404 from "../Error404";
import ChapterPage from "../ChapterPage";

export default (props) => {
    switch(props.params.slug) {
        case 'brokerage-continuum':
            return <BrokerageContinuum {...props}/>;
        case 'strive-pillars':
        case 'events':
        case 'roles-and-responsibilities':
            return <ChapterPage {...props}/>;
        case 'administration':
        case 'inspiration':
        case 'tips-of-the-trade':
            return <div style={{background: 'white', padding: '20px'}}>Work in progress</div>;
        default:
            return <Error404/>;
    }
}